import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Grid,
  Button,
  useMediaQuery,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Slide,
  useScrollTrigger,
  Container,
  Card,
  CardContent,
  CardMedia,
  Paper,
  IconButton as MuiIconButton,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import TextField from "@mui/material/TextField";
import EditIcon from "@mui/icons-material/Edit";

import MenuIcon from "@mui/icons-material/Menu";

// NAV_LINKS and HideOnScroll from UserHome.js
const NAV_LINKS = [
  { label: "Home", path: "/user-home" },
  { label: "Albums", path: "/user-albums" },
  { label: "Frames", path: "/user-frames" },
  { label: "Photo Selection", path: "/user-photo-selection" },
  { label: "Prices", path: "/user-prices" }, // <-- Make sure this is present!
  { label: "Contact", path: "/user-contact" },
  { label: "About", path: "/user-about" },
];

function HideOnScroll(props) {
  const { children } = props;
  const trigger = useScrollTrigger();
  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

const initialContent = {
  heroImg: "https://images.unsplash.com/photo-1465101046530-73398c7f28ca",
  heroTitle: "Contact Studio Art",
  heroSubtitle: "Let’s create beautiful memories together!",
  studioImg: "https://images.unsplash.com/photo-1519125323398-675f0ddb6308",
  studioTitle: "Studio Art Management",
  studioAddress: "123, Main Road, Madurai, Tamil Nadu, India",
  studioPhone: "+91 98765 43210",
  studioEmail: "studioart@gmail.com",
  studioInstagram: "@studioartmadurai",
  studioWhatsapp: "+91 91234 56789",
  studioMap:
    "https://maps.googleapis.com/maps/api/staticmap?center=Madurai,Tamil+Nadu,India&zoom=13&size=400x120&maptype=roadmap&markers=color:red%7Clabel:S%7CMadurai,Tamil+Nadu,India",
  descriptionTitle: "Welcome to Studio Art!",
  descriptionText:
    "Our team is passionate about capturing your most precious moments. Whether it’s a wedding, event, or portrait session, we blend creativity and professionalism to deliver stunning results. Reach out to us for bookings, collaborations, or any queries. We’re always happy to help you create memories that last a lifetime!",
  contactFormTitle: "Send Us a Message",
  contactFormSubtitle:
    "Fill out the form and our team will get back to you soon!",
  contactSideImg:
    "https://images.unsplash.com/photo-1506744038136-46273834b3fb",
  galleryTitle: "Studio Gallery",
  gallerySubtitle: "Explore our creative work and happy clients!",
  gallery: [
    {
      img: "https://images.unsplash.com/photo-1465101046530-73398c7f28ca",
      title: "Wedding Moments",
      desc: "Capturing the joy and love of your special day.",
      color: "rgba(25,118,210,0.85)",
    },
    {
      img: "https://images.unsplash.com/photo-1519125323398-675f0ddb6308",
      title: "Our Creative Team",
      desc: "Meet the passionate professionals behind Studio Art.",
      color: "rgba(139,94,60,0.85)",
    },
    {
      img: "https://images.unsplash.com/photo-1506744038136-46273834b3fb",
      title: "Artistic Portraits",
      desc: "Stunning portraits that reflect your personality and style.",
      color: "rgba(92,64,50,0.85)",
    },
  ],
};

const UserContact = () => {
  const [content, setContent] = useState(initialContent);
  const [footers, setFooters] = useState({});
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);
  const clientMongoId = localStorage.getItem("clientMongoId");
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    async function fetchContactPage() {
      if (!clientMongoId) return;
      try {
        const res = await axios.get(
          `https://studio-lc.onrender.com/api/clients/${clientMongoId}/contact-page`
        );
        if (res.data.contactPage) setContent(res.data.contactPage);
      } catch (err) {
        setContent(initialContent);
      }
    }
    fetchContactPage();
  }, [clientMongoId]);

  useEffect(() => {
    async function fetchFooters() {
      if (!clientMongoId) return;
      try {
        const res = await axios.get(
          `https://studio-lc.onrender.com/api/clients/${clientMongoId}/footers`
        );
        setFooters(res.data.footers || {});
      } catch (err) {
        setFooters({});
      }
    }
    fetchFooters();
  }, [clientMongoId]);

  const isMobile = useMediaQuery("(max-width:600px)");
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(
        `https://studio-lc.onrender.com/api/clients/${clientMongoId}/users/${userId}/contact-message`,
        form
      );
      alert("Message sent!");
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      alert("Failed to send message.");
    }
    setSending(false);
  };

  const handleEdit = (field, value) => {
    const newValue = prompt(`Edit ${field}`, value);
    if (newValue !== null) {
      setContent({ ...content, [field]: newValue });
      // Optionally, send this update to the server
      axios.patch(
        `https://studio-lc.onrender.com/api/clients/${clientMongoId}/contact-page`,
        { [field]: newValue }
      ).catch(err => console.error("Failed to update:", err));
    }
  };

  const studioName = localStorage.getItem("studioName") ;

  return (
   <Box
        sx={{
          bgcolor: "#fff",
          minHeight: "100vh",
          width: "100%",
          overflowX: "hidden"
        }}
      >
      {/* AppBar from UserHome.js */}
      <HideOnScroll>
        <AppBar
          position="fixed"
          sx={{
            bgcolor: "#fff",
            boxShadow: 3,
            height: isMobile ? 56 : 80,
            zIndex: 1201,
          }}
        >
          <Toolbar
            sx={{
              minHeight: isMobile ? 56 : 80,
              px: isMobile ? 1 : 3,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: isMobile ? "space-between" : "center",
            }}
          >
            <Typography
              variant={isMobile ? "h5" : "h4"}
              sx={{
                fontFamily: "josefin Sans",
                fontWeight: 900,
                color: "#8b5e3c",
                letterSpacing: 2,
                mr: isMobile ? 0 : 4,
                flexShrink: 0
              }}
            >
              {studioName}
            </Typography>
            {!isMobile && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 4,
                  flexGrow: 1,
                }}
              >
                {NAV_LINKS.map((link) => (
                  <Button
                    key={link.label}
                    href={link.path}
                    sx={{
                      color: "#8b5e3c",
                      fontWeight: 700,
                      fontSize: 22,
                      textTransform: "none",
                      letterSpacing: 1.5,
                      fontFamily: "josefin Sans",
                    }}
                  >
                    {link.label}
                  </Button>
                ))}
              </Box>
            )}
            {isMobile && (
              <IconButton
                edge="end"
                color="inherit"
                aria-label="menu"
                onClick={() => setDrawerOpen(true)}
                sx={{ ml: "auto" }}
              >
                <MenuIcon sx={{ color: "#8b5e3c", fontSize: 36, }} />
              </IconButton>
            )}
          </Toolbar>
        </AppBar>
      </HideOnScroll>
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <Box sx={{ width: 220, mt: 6 }}>
          <List>
            {NAV_LINKS.map((link) => (
              <ListItem
                button
                key={link.label}
                component="a"
                href={link.path}
                onClick={() => setDrawerOpen(false)}
              >
                <ListItemText
                  primary={link.label}
                  primaryTypographyProps={{
                    fontSize: 20,
                    fontWeight: 600,
                    color: "#8b5e3c",
                    fontFamily: "josefin Sans",
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
      <Box sx={{ height: isMobile ? 56 : 80 }} />
      {/* Hero Section */}
      <Box
        sx={{
          position: "relative",
          height: { xs: 220, md: 340 },
          mb: 6,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        <img
          src={content.heroImg}
          alt="Contact Hero"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            filter: "brightness(0.6)",
            position: "absolute",
            left: 0,
            top: 0,
            zIndex: 0,
          }}
        />
        <Box
          sx={{
            position: "relative",
            zIndex: 1,
            textAlign: "center",
            width: "100%",
          }}
        >
          <Typography
            variant="h2"
            sx={{
              color: "#fff",
              fontWeight: 700,
              fontFamily: "josefin Sans",
              letterSpacing: 2,
              mb: 1,
              textShadow: "0 2px 8px #333",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
            }}
          >
            {content.heroTitle}
            <IconButton sx={{ color: "#fff" }} onClick={() => handleEdit("heroTitle", content.heroTitle)}>
              <EditIcon />
            </IconButton>
          </Typography>
          <Typography
            variant="h6"
            sx={{
              color: "#fff",
              fontFamily: "jost",
              textShadow: "0 2px 8px #333",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              mt: 1,
            }}
          >
            {content.heroSubtitle}
            <IconButton sx={{ color: "#fff" }} onClick={() => handleEdit("heroSubtitle", content.heroSubtitle)}>
              <EditIcon />
            </IconButton>
          </Typography>
        </Box>
      </Box>

      <Container maxWidth="lg" sx={{ py: 4 }}>
        {/* Single Card with Studio Info and Description */}
        <Card
          sx={{
            borderRadius: 4,
            boxShadow: 6,
            bgcolor: "#fff",
            maxWidth: "2200px", // increased width
            width: { xs: "100%", md: "1400px" }, // increased width
            mx: "auto",
            ml: { xs: 0, md: -20 },
            mb: 6,
            p: { xs: 2, md: 4 },
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "stretch",
            gap: 4,
          }}
        >
          {/* Left: Studio Info */}
          <Box sx={{ flex: 1 }}>
            <Box sx={{ position: "relative" }}>
              <CardMedia
                component="img"
                image={content.studioImg}
                alt="Studio"
                sx={{
                  height: 180,
                  objectFit: "cover",
                  borderRadius: 2,
                  mb: 2,
                }}
              />
            </Box>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                color: "#8b5e3c",
               fontFamily: "josefin Sans",
                mb: 2,
                display: "inline-flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              {content.studioTitle}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              <LocationOnIcon sx={{ color: "#8b5e3c", mr: 1,fontFamily: "jost", }} />
              <Typography variant="body1" sx={{ color: "#5c4032",fontFamily: "jost", }}>
                {content.studioAddress}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", mb: 1,fontFamily: "jost", }}>
              <PhoneIcon sx={{ color: "#8b5e3c", mr: 1 }} />
              <Typography variant="body1" sx={{ color: "#5c4032",fontFamily: "jost", }}>
                {content.studioPhone}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", mb: 1, }}>
              <EmailIcon sx={{ color: "#8b5e3c", mr: 1 }} />
              <Typography variant="body1" sx={{ color: "#5c4032",fontFamily: "jost", }}>
                {content.studioEmail}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              <InstagramIcon sx={{ color: "#d32f2f", mr: 1 }} />
              <Typography variant="body1" sx={{ color: "#5c4032",fontFamily: "jost", }}>
                {content.studioInstagram}
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              <WhatsAppIcon sx={{ color: "#25D366", mr: 1 }} />
              <Typography variant="body1" sx={{ color: "#5c4032",fontFamily: "jost", }}>
                {content.studioWhatsapp}
              </Typography>
            </Box>
          </Box>
          {/* Right: Description */}
          <Box
            sx={{
              flex: 1,
              bgcolor: "#e7dfd5",
              borderRadius: 4,
              boxShadow: 2,
              p: 4,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                fontFamily: "josefin Sans",
                mb: 2,
                letterSpacing: 1,
                color: "#8b5e3c",
              }}
            >
              {content.descriptionTitle}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "jost",
                fontSize: 18,
                lineHeight: 1.8,
                color: "#5c4032",
              }}
            >
              {content.descriptionText}
            </Typography>
          </Box>
        </Card>

        {/* Contact Form with Side Image */}
        <Grid container spacing={6} alignItems="stretch">
          <Grid item xs={12} md={7}>
            <Paper
              elevation={3}
              sx={{
                borderRadius: 4,
                bgcolor: "#e7dfd5",
                p: { xs: 2, md: 6 },
                height: "100%",
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                alignItems: "center",
                gap: 4,
                ml: { xs: 0, md: -20 },
                width: { xs: "100%", md: "1380px" }, // increased width
                maxWidth: "2200px", // optional, for even larger screens
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 700,
                    color: "#8b5e3c",
                    fontFamily: "josefin Sans",
                    mb: 2,
                    letterSpacing: 1,
                  }}
                >
                  {content.contactFormTitle}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontFamily: "jost",
                    color: "#5c4032",
                    mb: 3,
                  }}
                >
                  {content.contactFormSubtitle}
                </Typography>
                <Box
                  component="form"
                  onSubmit={handleSubmit}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 3,
                  }}
                >
                  <TextField
                    label="Your Name"
                    name="name"
                    required
                    fullWidth
                    value={form.name}
                    onChange={handleChange}
                  />
                  <TextField
                    label="Your Email"
                    name="email"
                    required
                    fullWidth
                    type="email"
                    value={form.email}
                    onChange={handleChange}
                  />
                  <TextField
                    label="Message"
                    name="message"
                    required
                    fullWidth
                    multiline
                    minRows={4}
                    value={form.message}
                    onChange={handleChange}
                  />
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{
                      bgcolor: "#1976d2",
                      color: "#fff",
                      fontWeight: 600,
                      fontFamily: "jost",
                      mt: 2,
                      "&:hover": { bgcolor: "#1565c0" },
                    }}
                    disabled={sending}
                  >
                    Send Message
                  </Button>
                </Box>
              </Box>
              <Box
                sx={{
                  flex: 1,
                  position: "relative",
                  display: { xs: "none", md: "block" },
                }}
              >
                <img
                  src={content.contactSideImg}
                  alt="Contact Side"
                  style={{
                    width: "100%",
                    height: "320px",
                    objectFit: "cover",
                    borderRadius: "12px",
                    boxShadow: "0 2px 8px rgba(25,118,210,0.10)",
                  }}
                />
              </Box>
            </Paper>
          </Grid>
          <Grid item xs={12} md={5}></Grid>
        </Grid>

        {/* Gallery Section */}
        <Box sx={{ mt: 20, textAlign: "center" }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
               fontFamily: "josefin Sans",
              color: "#8b5e3c",
              mb: 2,
              letterSpacing: 1,
            }}
          >
            {content.galleryTitle}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontFamily: "jost",
              color: "#5c4032",
              mb: 3,
              fontSize: 18,
              maxWidth: 700,
              mx: "auto",
            }}
          >
            {content.gallerySubtitle}
          </Typography>
          <Grid container spacing={4} justifyContent="center" sx={{ mt: 3 }}>
            {content.gallery.map((item, idx) => (
              <Grid item xs={12} sm={6} md={4} key={idx}>
                <Card
                  sx={{
                    borderRadius: 4,
                    boxShadow: 6,
                    width: "362px",
                    transition: "transform 0.3s",
                    "&:hover": { transform: "scale(1.04)", boxShadow: 12 },
                    overflow: "hidden",
                    position: "relative",
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <CardMedia
                      component="img"
                      height="200"
                      image={item.img}
                      alt={item.title}
                      sx={{
                        filter: "brightness(0.85)",
                      }}
                    />
                  </Box>
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      width: "100%",
                      bgcolor: item.color,
                      color: "#fff",
                      py: 2,
                      px: 2,
                    }}
                  >
                    <Typography variant="h6" sx={{ fontWeight: 700 , fontFamily: "josefin Sans",}}>
                      {item.title}
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: "jost",}}>{item.desc}</Typography>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>

      {/* Footer Section */}
         {/* Footer Section */}
                  <Box
                         sx={{
                           bgcolor: "#a67c52",
                           color: "#fff",
                            fontFamily: "Josefin Sans",
                           mt: 4,
                           pt: 4,
                           pb: 2
                         }}
                       >
                         <Grid container spacing={2} sx={{ maxWidth: 1300, mx: "auto" }}>
                           {/* Left Column */}
                           <Grid item xs={12} md={3} sx={{ml: { xs: 3 }, mt: { xs: 6,  }}}>
                             <Typography variant="h5" sx={{ fontWeight: 700,  fontFamily: "Josefin Sans",  }}>
                               {footers.studio}
                             </Typography>
                             <Typography variant="body1" sx={{  fontFamily: "Jost",fontSize:17}}>{footers.tag}</Typography>
                             <Typography variant="body2" sx={{  fontFamily: "Jost",fontSize:17}}>{footers.handle}</Typography>
                           </Grid>
                           {/* Center Column */}
                           <Grid
                             item
                             xs={12}
                             md={6}
                             sx={{
                               display: "flex",
                               flexDirection: "column",
                               alignItems: "center",
                               justifyContent: "center",
                               ml: { xs: 0, md: 12 }
                             }}
                           >
                             <Typography
                               variant="body1"
                               sx={{
                                 textAlign: "center",
                                 fontSize: 18,
                                 mb: 2,
                                 fontFamily: "Jost",
                               }}
                             >
                               {footers.text}
                             </Typography>
                           </Grid>
                           {/* Right Column */}
                           <Grid item xs={12} md={3}>
                             <Box sx={{ display: "flex", gap: 2, mb: 2,ml: { xs: 3, md: 15 } ,mt: { xs: 6, md: 5 } }}>
                               {/* WhatsApp */}
                               <a href="https://wa.me/919123456789" target="_blank" rel="noopener noreferrer">
                                 <Box sx={{ bgcolor: "#25D366", borderRadius: "50%", p: 1 }}>
                                   <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" style={{ width: 28, height: 28 }} />
                                 </Box>
                               </a>
                               {/* Instagram */}
                               <a href="https://instagram.com/" target="_blank" rel="noopener noreferrer">
                                 <Box sx={{ bgcolor: "#fff", borderRadius: "50%", p: 1 }}>
                                   <img src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png" alt="Instagram" style={{ width: 28, height: 28 }} />
                                 </Box>
                               </a>
                               {/* Gmail */}
                               <a href="mailto:studioartmdu@gmail.com" target="_blank" rel="noopener noreferrer">
                                 <Box sx={{ bgcolor: "#fff", borderRadius: "50%", p: 1 }}>
                                   <img src="https://upload.wikimedia.org/wikipedia/commons/4/4e/Gmail_Icon.png" alt="Gmail" style={{ width: 28, height: 28 }} />
                                 </Box>
                               </a>
                               {/* YouTube */}
                               <a href="https://youtube.com/" target="_blank" rel="noopener noreferrer">
                                 <Box sx={{ bgcolor: "#fff", borderRadius: "50%", p: 1 }}>
                                   <img src="https://upload.wikimedia.org/wikipedia/commons/4/42/YouTube_icon_%282013-2017%29.png" alt="YouTube" style={{ width: 28, height: 28 }} />
                                 </Box>
                               </a>
                             </Box>
                           </Grid>
                           {/* Bottom Row */}
                           <Grid
                             item
                             xs={12}
                             sx={{
                               borderTop: "1px solid #fff2",
                               mt: 0,
                               ml: {xs:5, md:50},
                               pt: 2,
                               display: "flex",
                               flexDirection: { xs: "column", md: "row" },
                               justifyContent: "space-between",
                               alignItems: "center"
                             }}
                           >
                             <Typography variant="body2" sx={{ fontSize: 16,  fontFamily: "Josefin Sans", }}>
                               {footers.copyright}
                             </Typography>
                             <Typography variant="body2" sx={{ fontSize: 16,  fontFamily: "Josefin Sans", }}>
                               {footers.made}
                             </Typography>
                           </Grid>
                         </Grid>
                       </Box>
    </Box>
  );
};

export default UserContact;